import { useEffect, useState } from "react";

import { useOnboardingContext } from "@/views/ActivationView/partials/OnboardingContext";
import Typography from "@components/Typography";
import { useWizard } from "@components/Wizard";

import styles from "./LoadingNotice.module.css";

const LoadingNotice = () => {
  const { featuredMention, missingFeatured, user } = useOnboardingContext();
  const [seen, setSeen] = useState(false);

  // Display this view for a minimum of 3 seconds, as to not appear buggy
  useEffect(() => {
    window.setTimeout(() => setSeen(true), 3000);
  }, []);
  const { next } = useWizard();

  useEffect(() => {
    if (
      // Go on if we have a user ready and a featured mention
      (seen && user && featuredMention) ||
      // ... Or if we've concluded that there is no featured mention
      (seen && user && missingFeatured)
    ) {
      next();
    }
  }, [user, next, seen, featuredMention, missingFeatured]);

  return (
    <div className={styles.root}>
      <div>
        <Typography block variant="h1" align="center" className={styles.header}>
          {L.ACTIVATE_LOADING_TITLE}
        </Typography>
        <Typography align="center" variant="subtitle-1" block>
          {L.ACTIVATE_LOADING_SUBTITLE}
        </Typography>
        <div className={styles.loader}>
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingNotice;
